import React from 'react';
import estilos from './icone.module.css';

const IconeRegistros = () => {
    return (
        <svg viewBox="0 0 20 20" className={estilos.svg} arai-label="Ícone da página Registros.">
            <path d="M11.2109 0C10.8871 0 10.625 0.26207 10.625 0.585938V8.82812C10.625 9.15199 10.8871 9.41406 11.2109 9.41406H19.4141C19.7379 9.41406 20 9.15199 20 8.82812C20 3.98156 16.0575 0 11.2109 0Z" />

            <path d="M12.2964 18.6862L9.45312 11.0654V2.96875C9.45312 2.64488 9.19105 2.38281 8.86719 2.38281C4.02063 2.38281 0 6.32531 0 11.1719C0 16.0184 4.02063 20 8.86719 20C9.92805 20 10.9666 19.8118 11.9537 19.4409C12.2564 19.3271 12.4097 18.9895 12.2964 18.6862Z" />

            <path d="M19.4141 10.5859H11.2109C11.0187 10.5859 10.839 10.6804 10.7291 10.8383C10.6198 10.9962 10.5947 11.1976 10.6622 11.3779L13.5427 19.0982C13.5976 19.2436 13.7075 19.3614 13.8494 19.4255C13.9914 19.4901 14.1514 19.4955 14.298 19.4404C17.7083 18.1569 20 14.8111 20 11.1719C20 10.848 19.7379 10.5859 19.4141 10.5859Z"  />
        </svg>
    );
};

export default IconeRegistros;
